























import { computed, defineComponent, PropType } from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useGroupMembershipRole } from '@front-app/hooks/useMembershipRole';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import JoinButton from '@front-app/components/buttons/concrete/JoinButton.vue';

export default defineComponent({
	components: {
		PaddedContent,
		FontAwesomeIcon,
		JoinButton,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
		isJoiningGroup: Boolean,
		showLimitedPreview: Boolean,
		showJoinLink: Boolean,
	},
	setup(props) {
		const canDeclineInvitation = computed(() => useGroupMembershipRole(props.group.role).isInvitee);

		return {
			Size,
			canDeclineInvitation,
		};
	},
});
